import React from "react";

export const BorderContainer = ({ children, active, className }) => {
  return (
    <div
      className={`${className} px-8 py-12 rounded-xl md:mx-[52px] md:my-9 m-5 border shadow-lg ${active && "border-[#338CC7]"
        }`}
    >
      {children}
    </div>
  );
};
